<p-select
  [options]="sourceList"
  [multiple]="true"
  [ngModel]="selectedSources"
  (ngModelChange)="selectedSources = $event; onSourceChange()"
  [disabled]="disabled()"
  [appendTo]="appendTo()"
  panelStyleClass="p-select-checkbox-options"
  placeholder="All Sources"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selectedSources"
      [label]="chipLabel"
      [removable]="!disabled()"
      (removeItem)="removeSource($event)"
    />
  </ng-template>
</p-select>
